import React from 'react'
import { AddDropdown } from '@commonComponents/dropdown/AddDropdown'
const types = {
    addEU: 'addEU',
    addNL: 'addNL',
    pkgType: 'packageTypes',
    undg: 'UNDG'
}

const MUSearchable = (props) => {
    const {
        fieldName: { key, text, value },
        fieldValue,
        setFieldValue
    } = props

    return (
        <AddDropdown
            id={`${key}`}
            type={types[`${key}`]}
            label={text}
            selectedValue={fieldValue}
            disabled={!value?.trim()}
            onSelect={({ value }) => setFieldValue(value)}
            onBlur={({ value }) => {
                if (!value?.trim())
                    setFieldValue(value)
            }}
        />
    )
}

export default MUSearchable